module.exports = __webpack_public_path__ + "img/04.22092ce0.png";